import React from 'react';
import { FormattedMessage } from "react-intl";
import './Eingabe.css';

class EingabeDruckbereich extends React.Component {
    constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    }

  handleChange(event) {
        this.props.SelectedDruckbereich(event.target.value);
  }

  render() {
    return (
        <div>
          <label>
              <FormattedMessage id='Druckbereich' /></label>
              <select value={this.props.value} onChange={this.handleChange} disabled={"True"}>
                  <option key={1} value={"ND"}>{"ND"}</option>
                  <option key={2} value={"MD"}>{"MD"}</option>
                  <option key={3} value={"HD"}>{"HD"}</option>
              </select>

          {/*<p>{this.state.value}</p>*/}
        </div>
    );
  }
}
export default EingabeDruckbereich;
